import Icon from "components/Elements/Icon/Icon.tsx";

import { ButtonA } from "components/Elements/Button/Button.js";
import { useContent } from "contexts/contentContext/contentContext.js";

const EmbedQuestions = () => {
  const { getTextByKey, getHtmlByKey } = useContent();

  return (
    <div className="embed-questions-section">
      <h2>{getTextByKey("jumbo-forms-any-questions-title")}</h2>
      <p>{getTextByKey("jumbo-forms-contact-us-text")}</p>

      <div className="buttons-container">
        <ButtonA page="user/jumbo-forms/form-management">
          {getTextByKey("get-started")}
        </ButtonA>
        <ButtonA
          page="contact-us?subject=jumboforms"
          target="_blank"
          transparent
        >
          {getTextByKey("forms-contact-us")}
        </ButtonA>
      </div>
      <div className="read-more-section">
        <Icon name="portfolio" xxl blue />
        <span>{getHtmlByKey("read-more-for-biz")}</span>
      </div>
    </div>
  );
};

export default EmbedQuestions;
